module.exports = __webpack_public_path__ + "img/scan (11).87d2500e.png";